import React, { useContext, useEffect, useReducer, useMemo } from 'react'

import { Box, IconButton } from '@mui/material'
import { api } from '../../../services/api';
import toast from 'react-hot-toast'
import { getSession } from '../../../contexts/auth';
import { lockedReducer } from '../../Utils/reducers';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import ConfirmationDialog from '../../Utils/ConfirmationDialog';
import { externalComponent } from '../../AppRoutes';
import EditUserModal from './Edit-user-model';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import Table, { TableHook } from '../../Table';

const url = '/users/'

const submitDelete = async (data, setState, getData, setLoader) => {
    setLoader(true)
    const res = await api.delete(`${url}${data.id}/`)
    setLoader(false)
    if (res.status === 204) {
        toast.success('Deletado com sucesso')
        setState({ deleteRow: false })
        getData()
        return
    }
    else if (res.status === 400) {
        toast.error('Não é possível deletar o seu próprio usuário')
    }
    console.error('Falha ao deletar')

}

const columns = (setState, permissions) => {
    return [
        { field: 'first_name', headerName: 'Nome', flex: 1, filterType: 'string' },
        { field: 'last_name', headerName: 'Sobrenome', flex: 1, filterType: 'string' },
        { field: 'email', headerName: 'Email', flex: 1, filterType: 'string' },
        { field: 'phone_number', headerName: 'Telefone', flex: 1, filterType: 'string', filterMask: true },
        {
            field: 'is_active', headerName: 'Ativo', flex: .4, filterType: 'choices', choices:{'': 'Nenhum', '1': 'Ativo', '0': 'Inativo'},
            renderCell: ({ value }) => (
                <>
                    {value ?
                        <CheckCircleIcon sx={{ color: 'green' }} />
                        :
                        <HighlightOffIcon sx={{ color: 'red' }} />
                    }
                </>
            )
        },
        {
            field: 'actions', headerName: 'Ações', filterable: false,
            renderCell: (props) => {
                return (
                    <Box >
                        {permissions.change_user && <IconButton onClick={() => { setState({ editRow: props.row }) }}><EditIcon /></IconButton>}
                        {permissions.delete_user && <IconButton onClick={() => { setState({ deleteRow: props.row }) }}><DeleteIcon /></IconButton>}
                    </Box>
                )
            }
        }
    ]
}

export const loadData = async (setState, permission, setLoader) => {
    if (!permission) {
        toast.error('Você não tem permissão para ver os usuários')
        return
    }
    const requests = [
        api.get('/groupextension/'),
        api.get('/permissions/')
    ]
    const [groups, permissions] = await Promise.all(requests)
    const result = {}
    if (groups.status === 200)
        result.groups = groups.data.results
    if (permissions.status === 200)
        result.permissions = permissions.data.results
    setState({ ...result })
}

const Users = () => {


    const { setLoader } = useContext(externalComponent)

    const user = getSession()

    const [state, setState] = useReducer(lockedReducer, {
        users: [],
        groups: [],
        permissions: [],
        editRow: null,
        deleteRow: null
    })

    useEffect(() => {
        loadData(setState, user.permissions.view_user, setLoader)
    }, [setLoader, user.permissions.view_user])

    const [table, reloadTable] = TableHook()

    const reloadData = () => {
        loadData(setState, user.permissions.view_user, setLoader)
        reloadTable()
    }

    return (
        <>
            {state.deleteRow &&
                <ConfirmationDialog
                    content={`Deseja excluir o usuário ${state.deleteRow.email} - ${state.deleteRow.first_name} ${state.deleteRow.last_name}?`}
                    handleClose={() => setState({ deleteRow: null })}
                    onConfirm={() => submitDelete(state.deleteRow, setState, reloadData, setLoader)}
                />
            }
            {state.editRow &&
                <EditUserModal
                    data={state.editRow}
                    handleClose={() => setState({ editRow: null })}
                    reloadData={reloadData}
                    groups={state.groups}
                    permissions={state.permissions}
                />
            }
            <Box className='information-table'>
                <Box className='user-table'>
                    <Table
                        rows={state.users}
                        columns={useMemo(()=> columns(setState, user.permissions), [user.permissions])}
                        pagination
                        density='compact'
                        slots={{
                            returnComponent: ()=> window.backtobase(),
                            addComponent: user.permissions.add_user ? () => setState({ editRow: {} }) : null,
                            filterComponent: true,
                            columnComponent: true
                        }}
                        toolbar
                        getURL={url}
                        updateRows={(rows) => setState({'users': rows})}
                        innerRef={table}
                    />
                </Box>
            </Box>
        </>
    )
}

export default Users